import { XIcon } from '@/assets/icons/icons';
import CustomText from '@/components/common/CustomText';
import { createContext, useContext, useState, useCallback, useRef } from 'react';

const ToastContext = createContext(null);

export const ToastProvider = ({ children, timeout = 3000 }) => {
    const [show, setShow] = useState(false);
    const [message, setMessage] = useState('');
    const timerRef = useRef(null);

    const openToast = useCallback(
        (msg) => {
            setMessage(msg);
            setShow(true);
            if (timerRef.current) clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => {
                setShow(false);
            }, timeout);
        },
        [timeout]
    );

    const closeToast = useCallback(() => {
        setShow(false);
        if (timerRef.current) clearTimeout(timerRef.current);
    }, []);

    return (
        <ToastContext.Provider value={{ openToast, closeToast }}>
            {children}
            {show && (
                <div className="toast-message show" style={{}} onClick={closeToast}>
                    <CustomText semiBold fontSize="body6">
                        {message}
                    </CustomText>
                </div>
            )}
        </ToastContext.Provider>
    );
};

export const useToast = () => useContext(ToastContext);
